import { Page } from "@tfg/ui"
import { useTranslation } from "react-i18next"

export const SubSupplierMonitoring = () => {
  const { t } = useTranslation("suppliers")

  return <Page title={t("subSuppliers.title")} />
}
